import axios from 'axios'

import { parseAxiosErrorResponseData } from '@/utils/parseAxiosErrorResponseData'

const TOKEN_CHECK_THROTTLE_MS = 60_000 // at most once per minute
let lastTokenCheckAt = 0

// Dependency-injected interceptors to avoid coupling to Pinia stores at import time.
// Pass callbacks that use already-created stores in the app bootstrap (main.js).
export function setupApiInterceptors({ onUnauthorized, onNetworkIssue, onTokenCheck } = {}) {
    // Request: allow token inspection on each non-auth endpoint (throttled)
    axios.interceptors.request.use(
        (config) => {
            try {
                const url = config?.url || ''
                const now = Date.now()
                if (!url.includes('token') && now - lastTokenCheckAt >= TOKEN_CHECK_THROTTLE_MS) {
                    lastTokenCheckAt = now
                    if (typeof onTokenCheck === 'function') onTokenCheck()
                }
            } catch (_) {
                // do not block request on inspection errors
            }
            return config
        },
        (error) => Promise.reject(error)
    )

    // Response: handle auth/network
    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            try {
                if (error?.response?.data != null) {
                    error.response.data = await parseAxiosErrorResponseData(error.response.data)
                }

                const status = error?.response?.status
                const url = error?.config?.url || ''
                if (status === 401) {
                    if (!url.includes('token') && typeof onUnauthorized === 'function') {
                        onUnauthorized(error)
                    }
                } else if (error?.code === 'ECONNABORTED' || error?.message === 'Network Error') {
                    if (typeof onNetworkIssue === 'function') onNetworkIssue(error)
                }
            } catch (_) {
                // swallow
            }
            return Promise.reject(error)
        }
    )
}
